import {Collapse, VGMap} from "../../../../../modules/index.esm";

function onReady() {
	let $maps = document.querySelectorAll('[data-vg-map]');

	if ($maps.length) {
		for (let $map of $maps) {
			VGMap.init($map);
		}

		// локация пользователя
		if (('location' in App) && App.location) {
			VGMap.Location.init(function (data) {
				VGMapLocation.set(data)
			});
		}
	}

	const $mapStores = document.getElementById('yaMapStores');
	if ($mapStores) {
		VGMap.init('yaMapStores', {
			callback: {
				afterInitMap: function (map, params, _this) {
					VGMapCustom.run(map, params, _this);
				}
			}
		});
	}
}

document.addEventListener("DOMContentLoaded", onReady);
document.addEventListener("turbo:render", (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;
	onReady();
});

const VGMapCustom = {
	run: function (map, params, self) {
		// Карта инициализирована, все параметры получены. Дальше ебитесь сами!
		params.marker.color = 'red'
		let points = self.PlaceMark.set(map, params),
			$pointList = document.querySelectorAll('[data-map-toggle="address"]');

		let stores = document.querySelector('.stores');

		points.forEach(function (placemark, i) {
			placemark.events.add('click', function (e) {
				let target = e.get('target'),
					coordinates = target.geometry._coordinates;

				[...points].map((placemark) => {
					placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker.svg');
				})

				placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker-black.svg');

				map.setCenter(coordinates, 17);

				if ($pointList.length) {
					let address = stores.querySelectorAll('.address');
					[...address].map((address) => { address.classList.remove('show') });

					$pointList.forEach(function (point, n) {
						if (i === n) {
							let address = point.closest('.address'),
								collapse = point.closest('.accordion-item').querySelector('.collapse');

							if (collapse && !collapse.classList.contains('show')) {
								new Collapse(collapse, {
									toggle: true
								});
							}

							setTimeout(() => {
								scrollParentToChild(stores, address);
								address.classList.add('show')
							}, 300)
						}
					});
				}
			});
		});

		if ($pointList.length) {
			$pointList.forEach(function (point, i) {
				point.onclick = function () {
					[...$pointList].map((point) => {
						point.closest('.address').classList.remove('show')
					})

					this.closest('.address').classList.add('show');

					let coordinates = this.dataset.coord;
					if(coordinates) {
						coordinates = coordinates.split(',');
						map.setCenter(coordinates, 17);
						self.Map.offset(map, params);

						points.forEach(function (placemark, n) {
							if (i === n) {
								[...points].map((point) => {
									point.options.set('iconImageHref', '/assets/_frontend/images/icons/marker.svg');
								})

								placemark.options.set('iconImageHref', '/assets/_frontend/images/icons/marker-black.svg');
							}
						});
					}

					return false;
				};
			});
		}

		const cities = document.querySelectorAll('[data-map-toggle="city"]');
		[...cities].map((city) => {
			city.onclick = function () {
				let coordinates = city.dataset.coordinates;

				if(coordinates) {
					coordinates = coordinates.split(',');
					map.setCenter(coordinates, 9);
					self.Map.offset(map, params);
				}

				return false;
			};
		});
	},
}

function scrollParentToChild(parent, child) {
	let parentRect = parent.getBoundingClientRect(),
		parentViewableArea = {
			height: parent.clientHeight,
			width: parent.clientWidth
		},
		childRect = child.getBoundingClientRect(),
		isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

	if (!isViewable) {
		const scrollTop = childRect.top - parentRect.top;
		const scrollBot = childRect.bottom - parentRect.bottom;

		if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
			parent.scrollTop += scrollTop;
		} else {
			parent.scrollTop += scrollBot;
		}
	}
}

const VGMapLocation = {
	city: App.city || "Москва",
	coordinates: null,
	cities: App.cities || [],
	containers: [],
	isConfirmed: false,

	set: function (data) {
		let _this = this;

		_this = Object.assign({}, _this, data);
		_this.city = _this.geoObjects.get(0).getLocalities().join('');
		_this.coordinates = _this.geoObjects.get(0).geometry.getCoordinates();

		_this.containers.push(document.querySelectorAll('[data-location-city]') || null)
		document.body.setAttribute('data-location-confirm', 'false');

		let $containers = _this.containers,
			isConfirmed = document.body.dataset.locationConfirm || null;

		_this.isConfirmed = isConfirmed !== 'false';

		for (let containers of $containers) {
			for (const $container of containers) {
				$container.innerText = _this.city;

				if (!this.isConfirmed) {
					let spanElement = document.createElement('span');
					spanElement.classList.add('location-confirmed');
					spanElement.innerText = '?';

					$container.append(spanElement);
				}
			}
		}
	}
}
